<!-- Modal -->
<div
  class="modal fade confirm-modal"
  [id]="id ? id : 'basicModalCenter'"
  data-bs-backdrop="static"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <h4
        class="modal-header"
        style="text-align: center; margin: auto; margin-top: 20px"
        *ngIf="title"
      >
        {{ title }}
      </h4>
      <p
        class="modal-header"
        style="text-align: center; margin: auto"
        *ngIf="subtitle"
      >
        {{ subtitle }}
      </p>
      <p
        data-bs-dismiss="modal"
        [translatable]="{
          transKey: translationContent,
          modEnum: translationModulesEnum
        }"
      ></p>
      <div class="modal-body" *ngIf="!isPreviewMode">
        <span
          style="word-wrap: break-word; width: 100%"
          [title]="content | richTextToPlainText"
          class="text-center d-block content"
          [innerHTML]="truncate ? (content | truncate : 200) : content"
        ></span>
        <!--  booking request pricing section -->
        <div
          *ngIf="BookingRequestPricingAction"
          class="form-group mt-3"
          style="width: 90%"
        >
          <input
            type="number"
            id="bookingPrice"
            class="form-control"
            [(ngModel)]="bookingPrice"
            (input)="validatePrice($event)"
            min="0"
            maxlength="7"
            minlength="1"
            pattern="[0-9]{7}"
            [placeholder]="'booking.details.bookingDynamicPrice' | translate"
          />
          <small *ngIf="priceError" class="text-danger mt-1">
            {{ priceError }}
          </small>
        </div>
        <!-- end booking request pricing section -->

        <app-select
          style="width: 90%"
          *ngIf="entities && entities.length > 0"
          class="d-block"
          [placeholder]="
            'requests.advancedFilterModal.selectstatus' | translate
          "
          [labelTranslationKey]="'requests.advancedFilterModal.status'"
          [labelTranslationModuleEnum]="translationModulesEnum"
          [placeholderTranslationKey]="
            'requests.advancedFilterModal.selectstatus'
          "
          [placeholderTranslationModuleEnum]="translationModulesEnum"
          [items]="entities"
          [bindVlaue]="'id'"
          [bindLabel]="lang === 'ar' ? 'name.ar' : 'name.en'"
          [clearable]="true"
          [resetSelectionTrigger]="resetSelectedEntity"
          (change)="changeEntity($event)"
        ></app-select>
      </div>
      <div class="modal-body" *ngIf="isPreviewMode && dataToPreview">
        <div class="container">
          <div class="row">
            <div class="col">
              <p
                [translatable]="{
                  transKey: 'membership.members.amount',
                  modEnum: translationModulesEnum
                }"
              >
                <strong>{{ "membership.members.amount" | translate }}:</strong>
                {{ dataToPreview.amount }}
              </p>
              <p
                [translatable]="{
                  transKey: 'membership.members.paymentMethod',
                  modEnum: translationModulesEnum
                }"
              >
                <strong>
                  {{ "membership.members.paymentMethod" | translate }}:
                </strong>
                {{
                  dataToPreview.paymentMethod === null
                    ? lang === "ar"
                      ? "لا يوجد"
                      : "N/A"
                    : dataToPreview.paymentMethod
                }}
              </p>
              <p
                [translatable]="{
                  transKey: 'membership.members.paymentDate',
                  modEnum: translationModulesEnum
                }"
              >
                <strong>
                  {{ "membership.members.paymentDate" | translate }}:
                </strong>
                {{
                  dataToPreview.paymentDate === null
                    ? lang === "ar"
                      ? "لا يوجد"
                      : "N/A"
                    : (dataToPreview?.paymentDate
                      | uTCToLocalDate
                      | localizedDate : "d MMM y / h:mm a")
                }}
              </p>
              <p
                [translatable]="{
                  transKey: 'membership.members.status',
                  modEnum: translationModulesEnum
                }"
              >
                <strong>{{ "membership.members.status" | translate }}:</strong>
                {{ dataToPreview.status }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer" *ngIf="isPreviewMode">
        <button
          type="button"
          [class]="'btn btn-' + btnStyle"
          data-bs-dismiss="modal"
          (click)="onCancel()"
        >
          {{ "shared.ok" | translate }}
        </button>
      </div>
      <div class="modal-footer" *ngIf="attendanceErr">
        <button
          type="button"
          *ngIf="attendanceErr"
          class="btn btn-outline-main"
          data-bs-dismiss="modal"
          (click)="onCancel()"
        >
          {{ "shared.ok" | translate }}
        </button>
      </div>
      <div class="modal-footer" *ngIf="!isPreviewMode && !attendanceErr">
        <button
          type="button"
          *ngIf="!showOkOnlyBtn"
          class="btn btn-outline-main"
          data-bs-dismiss="modal"
          (click)="onCancel()"
        >
          {{ backBtnContent | translate }}
        </button>
        <button
          type="button"
          *ngIf="!showOkOnlyBtn"
          class="btn"
          [class]="'btn btn-' + btnStyle"
          data-dismiss="modal"
          (click)="modalconfirm()"
        >
          {{ btnContent | translate }}
        </button>
        <button
          type="button"
          [class]="'btn btn-' + btnStyle"
          data-bs-dismiss="modal"
          (click)="onCancel()"
          *ngIf="showOkOnlyBtn"
        >
          {{ "shared.ok" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
